import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { MediaSourcesResponse } from "@ckgo2/shared/types";
import { api, type ApiResponse } from "@/api/client";

/**
 * Prefix klíče seznamu stránky Média (`useInfiniteQuery` s filtry za ním). Kdo mění fotky
 * v seznamu, zneplatní tenhle prefix.
 */
export const MEDIA_LIST_KEY = ["media-files"] as const;

/**
 * Klíč dřívějších zdrojů fotek. Kdo mění `source` (uložení detailu, hromadný zdroj),
 * zneplatní ho, aby nabídka zdrojů znala novou hodnotu.
 */
export const MEDIA_SOURCES_KEY = ["media-sources"] as const;

/**
 * Dřívější zdroje fotek, česky abecedně (`GET /api/admin/upload/sources`). JEDINÝ čtenář
 * té trasy v adminu: filtr stránky Média, detail fotky i hromadná lišta berou nabídku
 * odsud, ať sdílí jeden dotaz a jedno zneplatnění.
 */
export function useMediaSources(): UseQueryResult<string[]> {
  return useQuery({
    queryKey: MEDIA_SOURCES_KEY,
    queryFn: () => api.get<ApiResponse<MediaSourcesResponse>>("/api/admin/upload/sources"),
    select: (r) => r.data?.sources ?? [],
    staleTime: 60_000,
  });
}
